<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-module-submodule-select
              :pageId="pageId"
              :selectedMd="batchJobHistoryData.moduleCode"
              :selectedSmd="batchJobHistoryData.subModuleCode"
              :disabled="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobId"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_BCJB_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobName"
              max-length="100"
              readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_CYCL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobCycle"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_IF_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.interfaceId"
              max-length="100"
              readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_BF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.beforeBatchJobId"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_AF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.afterBatchJobId"
              max-length="100"
              readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRTC_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobPracticeId"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PROC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobGenerateDTM"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRTC_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model.trim="batchJobHistoryData.batchJobPracticeContent"
              name="name"
              rows="5"
              maxlength="1000"
              class="width100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_ERR_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model.trim="batchJobHistoryData.batchJobErrorCode"
              max-length="100"
              readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_ERR_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model.trim="batchJobHistoryData.batchJobErrorContent"
              name="name"
              rows="5"
              maxlength="1000"
              class="width100"
              readonly="true"
            />
          </div>
        </div>
      </div>
    </sui-page-contents>

    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClose"
        >
          {{ $t("MSG_BTN_CLOSE") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00007', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      batchJobId: {
        type: String,
      },
      batchJobHistoryUID: {
        type: String,
      },
      default: null,
    },
  },
  data() {
    return {
      batchJobHistoryData: {
        moduleCode: { key: '', label: '' },
        moduleName: '',
        subModuleCode: { key: '', label: '' },
        subModuleName: '',
        batchJobId: '',
        batchJobName: '',
        batchJobCycle: '',
        interfaceId: '',
        beforeBatchJobId: '',
        afterBatchJobId: '',

        batchJobPracticeId: '',
        batchJobGenerateDTM: '',
        batchJobPracticeContent: '',
        batchJobErrorCode: '',
        batchJobErrorContent: '',

        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    if (utils.isEmpty(this.pageInitialData.batchJobId) || utils.isEmpty(this.pageInitialData.batchJobHistoryUID)) {
      utils.alert(utils.strFormat(this.$t('MSG_ALT_CHK_CONFIRM'),
        this.$t('MSG_TXT_BCJB_ID')), this.$t('MSG_BTN_CFRM'), () => { this.closePagePopup(''); });
      // return false;
      return;
    }

    this.searchBatchJobHistory(this.pageInitialData.batchJobId, this.pageInitialData.batchJobHistoryUID);
    // return true;
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    // 내부 함수 기술
    // 이벤트 핸들러 기술, prefix on 적용
    onDatasetSelectionChanged(selections) {
      console.log(selections);
    },
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onClose() {
      this.closePagePopup('');
    },
    /** ***************************************************************************
      함수 영역
      ***************************************************************************** */
    searchBatchJobHistory(sBatchJobId, sBatchJobHistoryUID) {
      http.request('PGE_CMS_00007', 'DTS_CMS_00017', {
        path: {
          'batch-job-id': utils.trim(sBatchJobId),
          'batch-job-history-uid': utils.trim(sBatchJobHistoryUID),
        },
      }).then(res => {
        const has = Object.prototype.hasOwnProperty;

        res.data.batchJobGenerateDTM = utils.dateformatToClient(res.data.batchJobGenerateDTM);

        utils.forEach(res.data, (value, key) => {
          if (utils.has(this.batchJobHistoryData, key)) {
            if (has.call(this.batchJobHistoryData[key], 'key')) {
              utils.set(this.batchJobHistoryData, key, { key: value, label: '' });
            } else {
              utils.set(this.batchJobHistoryData, key, value);
            }
          }
        });
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
